import Vue from 'vue'
import * as types from 'store/mutation-types'

const actions = {
  loadUsBriefInfo({ commit, dispatch }, { symbol, market }) {
    const industry = () =>
      Vue.http.get(`~stock/market/plate/belonged/${symbol}`).then(resp => {
        if (resp.data.ret !== 0) {
          return []
        }
        return resp.data.items
      })
    const usIntro = () =>
      Vue.http.get(`~stock/stock_info/profile/${symbol}`).then(({ data }) => {
        if (data.ret === 0 && data.items) {
          return data.items[0]
        }
        return {}
      })
    const usResearch = () =>
      Vue.http
        .get(`~stock/fundamental/usstock/publicity/research/${symbol}`)
        .then(({ data }) => {
          if (data.ret === 0 && data.data) {
            return data.data.research
          }
          return {}
        })
    const usFunds = () =>
      Vue.http
        .get(`~stock/stock_info/publicity_fund_with_medium/${symbol}`)
        .then(resp => {
          if (resp.data.ret !== 0) {
            return {}
          }
          return resp.data.fund
        })
    const usOrgHoldings = () =>
      Vue.http.get(`~stock/stock_info/org_hold/${symbol}`).then(resp => {
        if (resp.data.ret !== 0) {
          return {}
        }
        const { holdSummary, recently } = resp.data
        return {
          holdSummary,
          recently
        }
      })

    return Promise.all([
      usIntro(),
      industry(),
      usResearch(),
      usFunds(),
      usOrgHoldings()
    ]).then(([intro, industry, research, funds, orgHoldings]) => {
      return commit(types.LOAD_BRIEF_DATA, {
        intro,
        industry,
        research,
        funds,
        orgHoldings
      })
    })
  }
}

export default {
  actions
}
